module.exports = __webpack_public_path__ + "static/media/img90.23952403.jpg";